import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { map,catchError, } from 'rxjs/operators';
import { EnvService } from '../services/env.service';


const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  //baseUrl  = "http://localhost:3000/customers"; 
  dataRow : any;

  constructor(private http: HttpClient,private env: EnvService) {

   }

   getMaxId() :Observable <any[]>{
     return this.http.get<any[]>(`${this.env.apiUrl}/customers/getMaxId`,httpOptions)
     .pipe(catchError(this.handleError));
        
     }

   getAll():Observable <any[]> {
    return this.http.get<any[]>(`${this.env.apiUrl}/customers`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }

    getCustomer(cusId:string):Observable <any> {
      return this.http.get<any>(`${this.env.apiUrl}/customers/${cusId}`,httpOptions)
      .pipe(catchError(this.handleError));
         
      }



    addCustomer(data):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/customers`,  data ,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    updateCustomer(data):Observable <void>{
      return this.http.put<void>(`${this.env.apiUrl}/customers`, data ,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    deleteCustomer(cusId: string) : Observable <void>{
      return this.http.delete<void>(`${this.env.apiUrl}/customers/${cusId}`,httpOptions)
        .pipe(catchError(this.handleError));
       
    }



    private handleError(errorResponse: HttpErrorResponse) {
      return throwError(errorResponse || "Server Error");

      }
      
     }

